import { ShieldOff } from "lucide-react";

export const VerifiedUnavailable = ({ note, testId = "verified-unavailable" }) => (
  <div
    data-testid={testId}
    className="metric-empty w-full py-14 px-6 flex flex-col items-center justify-center text-center gap-3"
  >
    <ShieldOff className="w-6 h-6 text-muted-foreground" strokeWidth={1.5} />
    <p className="font-mono-data text-sm uppercase tracking-[0.2em] text-muted-foreground">
      Verified data unavailable
    </p>
    {note && <p className="text-xs text-muted-foreground/80 max-w-md leading-relaxed">{note}</p>}
  </div>
);
